import { http } from '@jota-one/http-client'

import npm from '../../package.json'

const $clients = {}

const createClient = ({ baseURL = '/', name = 'default' }) => {
  if ($clients[name] === undefined) {
    $clients[name] = http({
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      baseURL,
    })
  }

  return $clients[name]
}

const loadLabels = lang => import(`../i18n/${lang}.terms.json`)

const loadTermsConfig = async () => {
  const response = await $clients.api('public/customerprofile/public/v1/terms')
  return response.data.data
}

const loadTermsContent = async (baseUrl, prefix, type, version, lang) => {
  const infix = `${prefix}.${type.toLowerCase()}.${version}.${lang}`
  const response = await $clients.content(
    `${baseUrl}/sanitas-legal.${infix}.json`,
  )

  return response.data
}

createClient({ name: 'content' })
createClient({ name: 'api' })

console.info(
  '%c ⚑ sani%ctas%c Terms Vue2',
  'font-weight:bold;color:#00765A;',
  'font-weight:bold;color:#5BAC26;',
  'font-weight:bold;color:#AAAAAA;',
  `v${npm.version}`,
)

export { createClient, loadLabels, loadTermsConfig, loadTermsContent }
